module.exports = __webpack_public_path__ + "media/images/application/template/icon--link-external-f635cc9707a6f558efc5509760aedd11.svg";